import ComingSoon from "@/components/ComingSoon";
import UnderConstructionSvg from "@/components/UnderConstructionSvg";

export default function PatchingPage() {
  return <ComingSoon featureName="Under Construction" description="Manage macOS/iOS updates, create patch policies, and monitor compliance. This feature requires backend Patch Management APIs." illustration={<UnderConstructionSvg />} />;
}
